// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMessageUnpinBody = {
  messageId: string;
};

export type typeMessageUnpinOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isPinned: boolean };
};

export type typeMessageUnpinOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageUnpinOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageUnpinOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMessageUnpinBody = {
  type: "object",
  properties: { messageId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["messageId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMessageUnpin(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMessageUnpinBody);
  }

  return async function postMessageUnpin(
    payload: typeMessageUnpinBody,
  ): Promise<typeMessageUnpinOutput200 | typeMessageUnpinOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMessageUnpin" failed before calling the network. #5c281c28def9`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#5c281c28def9" },
        },
        data: null,
      } as typeMessageUnpinOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/message/unpin`,
      httpMethod: "POST",
      options,
    })) as typeMessageUnpinOutput200 | typeMessageUnpinOutput400;
  };
}
